type Env = 'development' | 'staging' | 'production'
export const getEnvironmentFromWindowLocation = (): Env => {
  const { hostname } = window.location

  if (/netlify\.(app|com)$/.test(hostname)) {
    return 'production'
  }

  if (/netlifystg\.(app|com)$/.test(hostname)) {
    return 'staging'
  }

  return 'development'
}
